import React from 'react'
import { Button, FormGroup, Input, Label } from 'reactstrap'
import Select from 'react-select'

import Modal from './Modal'
import { motivosCancelacionCFDI, motivosCancelacionPagos20 } from '../helpers/cancelacionCFDI'

const CancelacionCFDIModal = ({
    isOpen,
    title,
    cancelReason,
    folioSustitucion,
    showFolioSustitucion,
    onCancelReasonChange,
    onFolioSustitucionChange,
    onConfirm,
    onRequestClose,
    pagos20 = false
}) => {
    return (
        <Modal
            title={title}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            body={(
                <React.Fragment>
                    <FormGroup>
                        <Label htmlFor="motivoCancelacion">
                            Motivo de Cancelación *
                        </Label>

                        <Select
                            inputId="motivoCancelacion"
                            value={cancelReason}
                            placeholder="Selecciona el motivo de cancelación"
                            onChange={onCancelReasonChange}
                            options={pagos20  ? motivosCancelacionPagos20 : motivosCancelacionCFDI}
                            classNamePrefix="select2-selection"
                        />
                    </FormGroup>

                    {showFolioSustitucion && (
                        <FormGroup>
                            <Label>Folio de Nueva Factura:</Label>

                            <Input
                                type="text"
                                value={folioSustitucion}
                                placeholder="Escribe el Folio Fiscal de la nueva factura expedida"
                                onChange={(event) => {
                                    onFolioSustitucionChange(event.target.value)
                                }}
                            />
                        </FormGroup>
                    )}
                </React.Fragment>
            )}
            footer={(
                <Button color="danger" onClick={onConfirm}>
                    Confirmar Cancelación
                </Button>
            )}
        />
    )
}

export default CancelacionCFDIModal
